import { render, staticRenderFns } from "./ServiceOrderList.vue?vue&type=template&id=2bc71ff7&scoped=true&"
import script from "./ServiceOrderList.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderList.vue?vue&type=style&index=0&id=2bc71ff7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc71ff7",
  null
  
)

export default component.exports